import type { ModuleFile } from '../../core/modules.ts';

// Módulo «results»: manifiesto. Las pantallas se cargan de forma perezosa.
export const manifests: ModuleFile['manifests'] = [
  {
    id: 'results',
    title: 'Resultados',
    path: 'resultados',
    nav: { group: 'Canal', label: 'Resultados', icon: '↗', order: 3 },
    load: () => import('./ResultsPage.tsx').then((m) => ({ default: m.ResultsPage })),
  },
];
